// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `group-overview {
  position: relative;
  display: block;
  box-sizing: border-box;
  width: 100%;
}
group-overview .share p {
  margin: var(--motes-padding);
}
group-overview .leave {
  padding: var(--motes-padding);
}
group-overview .group-id,
group-overview .group-id-loading {
  display: block;
  min-height: 2.2rem;
  padding-top: 0.2em;
  font-size: 25px;
  color: var(--motes-highlight-color);
}
group-overview .group-id {
  cursor: pointer;
}
group-overview .group-id-loading svg-icon {
  font-size: 2em;
}
group-overview .loading-overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: var(--darker-bg-color);
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/group-overview/group-overview.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;AACJ;AACI;EACI,4BAAA;AACR;AAEI;EACI,6BAAA;AAAR;AAGI;;EAEI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;AADR;AAII;EACI,eAAA;AAFR;AAKI;EACI,cAAA;AAHR;AAMI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,oBAAA;AAJR","sourcesContent":["group-overview {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n\n    .share p {\n        margin: var(--motes-padding);\n    }\n\n    .leave {\n        padding: var(--motes-padding);\n    }\n\n    .group-id,\n    .group-id-loading {\n        display: block;\n        min-height: 2.2rem;\n        padding-top: 0.2em;\n        font-size: 25px;\n        color: var(--motes-highlight-color);\n    }\n\n    .group-id {\n        cursor: pointer;\n    }\n\n    .group-id-loading svg-icon {\n        font-size: 2em;\n    }\n\n    .loading-overlay {\n        position: absolute;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        background-color: var(--darker-bg-color);\n        pointer-events: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
